import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import NavBar from '../../NavBar.jsx';
import ImageFlipBook from '../../ImageFlipBook.jsx';
import { FaArrowLeft } from 'react-icons/fa';

function NewsletterViewer() {
  const { id } = useParams();
  const navigate = useNavigate();

  const newsletters = [
    {
      title: "Fall-Winter 2025/2026",
      images: [
        "/newsletter/Fall_Winter_25_26/2.png",
        "/newsletter/Fall_Winter_25_26/3.png",
        "/newsletter/Fall_Winter_25_26/4.png",
        "/newsletter/Fall_Winter_25_26/5.png",
        "/newsletter/Fall_Winter_25_26/6.png",
        "/newsletter/Fall_Winter_25_26/7.png",
        "/newsletter/Fall_Winter_25_26/8.png",
        "/newsletter/Fall_Winter_25_26/9.png",
        "/newsletter/Fall_Winter_25_26/10.png",
        "/newsletter/Fall_Winter_25_26/11.png",
        "/newsletter/Fall_Winter_25_26/12.png",
        "/newsletter/Fall_Winter_25_26/13.png",
        "/newsletter/Fall_Winter_25_26/14.png"
      ]
    },
    {
      title: "Newsletter Spring-Summer 2025",
      images: [
        "/newsletter/25/2.png",
        "/newsletter/25/3.png",
        "/newsletter/25/4.png",
        "/newsletter/25/5.png",
        "/newsletter/25/6.png",
        "/newsletter/25/7.png",
        "/newsletter/25/8.png",
        "/newsletter/25/9.png",
        "/newsletter/25/10.png",
        "/newsletter/25/11.png",
        "/newsletter/25/12.png",
        "/newsletter/25/13.png",
        "/newsletter/25/14.png",
        "/newsletter/25/15.png",
        "/newsletter/25/16.png",
        "/newsletter/25/17.png",
        "/newsletter/25/18.png",
        "/newsletter/25/19.png",
        "/newsletter/25/20.png",
      ]
    },
    {
      title: "Newsletter Fall-Winter 2024/2025",
      images: [
        "/newsletter/24_25/2.png",
        "/newsletter/24_25/3.png",
        "/newsletter/24_25/4.png",
        "/newsletter/24_25/5.png",
        "/newsletter/24_25/6.png",
        "/newsletter/24_25/7.png",
        "/newsletter/24_25/8.png",
        "/newsletter/24_25/9.png",
        "/newsletter/24_25/10.png",
        "/newsletter/24_25/11.png",
        "/newsletter/24_25/12.png"
      ]
    },
    {
      title: "Newsletter Spring-Summer 2024",
      images: [
        "/newsletter/23_24/1_newsletter.png",
        "/newsletter/23_24/2_newsletter.png",
        "/newsletter/23_24/3_newsletter.png",
        "/newsletter/23_24/4_newsletter.png",
        "/newsletter/23_24/5_newsletter.png",
        "/newsletter/23_24/6_newsletter.png",
        "/newsletter/23_24/7_newsletter.png",
        "/newsletter/23_24/8_newsletter.png",
        "/newsletter/23_24/9_newsletter.png",
        "/newsletter/23_24/10_newsletter.png",
        "/newsletter/23_24/11_newsletter.png",
        "/newsletter/23_24/12_newsletter.png"
      ]
    }
  ];

  const newsletter = newsletters[newsletters.length - id];

  return (
    <>
      <NavBar activeSection="" />
      <button
        onClick={() => navigate('/')}
        className="fixed top-20 left-4 z-30 text-white/70 hover:text-white hover:scale-110 transition-all p-3 bg-black/30 rounded-full"
      >
        <FaArrowLeft size={24} />
      </button>
      <ImageFlipBook images={newsletter.images} />
    </>
  );
}

export default NewsletterViewer;